import React from "react";
import { useForm } from "react-hook-form";
import api from "../../api/api";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";

export default function Create({ setOption }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const onSubmit = (data) => {
    api
      .post("banners/body", data)
      .then((response) => setOption("view"))
      .catch((error) => console.error("Houve um erro na solicitação", error));
  };

  return (
    <div className="space-y-4">
      <Button
        onClick={() => setOption("view")}
        variant="outlined"
        color="primary"
        sx={{ mb: 5 }}
      >
        <ArrowBackIcon />
        Voltar
      </Button>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Titulo
          </label>

          <input
            type="text"
            placeholder="Titulo"
            {...register("name", {
              required: "Este campo é obrigatório",
              maxLength: 100,
            })}
            className="block w-full p-2 border rounded-md"
          />
          <p className="text-xs text-gray-500 mt-2">
            Nome para o banner, será exibido somente no painel administrativo
          </p>
          {errors.name && (
            <span className="text-red-500">{errors.name.message}</span>
          )}
        </div>

        <div>
          <label
            htmlFor="text"
            className="block text-sm font-medium text-gray-700"
          >
            Descrição
          </label>

          <input
            type="text"
            placeholder="text"
            {...register("text", {
              required: "Este campo é obrigatório",
              maxLength: 100,
            })}
            className="block w-full p-2 border rounded-md"
          />
          <p className="text-xs text-gray-500 mt-2">
            Descrição para o banner, será exibido somente no painel
            administrativo
          </p>
          {errors.text && (
            <span className="text-red-500">{errors.text.message}</span>
          )}
        </div>

        <div>
          <label
            htmlFor="href"
            className="block text-sm font-medium text-gray-700"
          >
            Link
          </label>
          <input
            type="text"
            placeholder="Ex:
                produtos?category=categoryID"
            {...register("href")}
            className="block w-full p-2 border rounded-md"
          />
          <p className="text-xs text-gray-500 mt-2">
            Caminho de redirecionamento, este categoryID pode ser retirado do
            próprio site, ou na seção de categorias.
          </p>
          {errors.href && (
            <span className="text-red-500">{errors.href.message}</span>
          )}
        </div>

        <div className="flex gap-2 w-full">
          <div className="w-1/2">
            <label
              htmlFor="imgUrl"
              className="block text-sm font-medium text-gray-700"
            >
              Imagem Desktop
            </label>
            <input
              type="text"
              placeholder="Ex: https://i.imgur.com/LIz7pxN.jpg"
              {...register("imgUrl")}
              className="block w-full p-2 border rounded-md"
            />
            <p className="text-xs text-gray-500 mt-2">
              Link da imagem Desktop (1028x1296)
            </p>
            {errors.imgUrl && (
              <span className="text-red-500">{errors.imgUrl.message}</span>
            )}
          </div>

          <div className="w-1/2">
            <label
              htmlFor="imgUrlMobile"
              className="block text-sm font-medium text-gray-700"
            >
              Imagem Mobile
            </label>
            <input
              type="text"
              placeholder="Ex: https://i.imgur.com/LIz7pxN.jpg"
              {...register("imgUrlMobile")}
              className="block w-full p-2 border rounded-md"
            />
            <p className="text-xs text-gray-500 mt-2">
              Link da imagem Mobile (1028x1296)
            </p>
            {errors.imgUrlMobile && (
              <span className="text-red-500">
                {errors.imgUrlMobile.message}
              </span>
            )}
          </div>
        </div>

        <div className="flex justify-start">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition ease-in-out duration-150 mt-4 w-full"
          >
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
}
